import request from "@/common/request"
import { DetalhesPagamentoEmCheque } from "@/models"

const basePath = '/detalhesDoCheque'

export const criarPagamentoEmCheque = (pagamento: DetalhesPagamentoEmCheque): Promise<DetalhesPagamentoEmCheque> => 
	request.post(`${basePath}`, {...pagamento})

export const removerPagamentoEmCheque = (detalhesPagamentoEmChequeId: string): Promise<void> =>
	request.post(`${basePath}/remover/${detalhesPagamentoEmChequeId}`)

export const findByTituloId = (tituloId: string): Promise<DetalhesPagamentoEmCheque> =>
	request.get(`${basePath}/${tituloId}`)